import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=ad25232c"
import script from "./UserProfileEdit.vue?vue&type=script&lang=ts"
export * from "./UserProfileEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports